import { createPageSchema as e, opaqueCursorSchema as t, pageLimitSchema as n, uuidSchema as r } from "../common/index.js";
import { z as i } from "zod";
// src/teams/index.ts
var a = 100, o = 2e3;
function s(e) {
	return e.normalize("NFC").trim().toLocaleLowerCase("und");
}
var c = i.string().transform((e) => e.normalize("NFC").trim()).pipe(i.string().min(1).max(100)), l = i.string().max(o).nullable(), u = i.object({
	id: r,
	name: c,
	description: l,
	active: i.boolean(),
	version: i.number().int().positive(),
	createdAt: i.string().datetime({ offset: !0 }),
	updatedAt: i.string().datetime({ offset: !0 })
}).strict(), d = i.object({
	name: c,
	description: l.optional()
}).strip(), f = i.object({
	name: c.optional(),
	description: l.optional(),
	active: i.boolean().optional(),
	expectedVersion: i.number().int().positive()
}).strip().refine((e) => e.name !== void 0 || e.description !== void 0 || e.active !== void 0, "Provide at least one team field to update."), p = i.object({
	query: i.string().max(100).optional(),
	active: i.stringbool().optional(),
	cursor: t.optional(),
	limit: n
}).strip(), m = e(u), h = i.object({
	id: r,
	teamId: r,
	userId: r,
	displayName: i.string().min(1).max(200),
	startedAt: i.string().datetime({ offset: !0 }),
	endedAt: i.string().datetime({ offset: !0 }).nullable(),
	version: i.number().int().positive(),
	teamActive: i.boolean(),
	effective: i.boolean()
}).strict(), g = i.object({
	userId: r,
	expectedTeamVersion: i.number().int().positive()
}).strip(), _ = i.object({ expectedVersion: i.number().int().positive() }).strip(), v = i.object({
	includeEnded: i.stringbool().optional(),
	cursor: t.optional(),
	limit: n
}).strip(), y = e(h), b = i.object({
	teamId: r,
	active: i.boolean(),
	changeKind: i.enum([
		"created",
		"updated",
		"deactivated",
		"reactivated"
	])
}).strict(), x = i.object({
	membershipId: r,
	teamId: r,
	userId: r,
	changeKind: i.enum(["added", "removed"])
}).strict();
export { o as TEAM_DESCRIPTION_MAX_LENGTH, a as TEAM_NAME_MAX_LENGTH, x as membershipChangedEventSchema, g as membershipCreateSchema, _ as membershipEndSchema, v as membershipListQuerySchema, y as membershipPageSchema, h as membershipSummarySchema, s as normalizeTeamName, b as teamChangedEventSchema, d as teamCreateSchema, l as teamDescriptionSchema, p as teamListQuerySchema, c as teamNameSchema, m as teamPageSchema, u as teamSummarySchema, f as teamUpdateSchema };

//# sourceMappingURL=index.js.map